// Audio System Types

/* eslint-disable no-unused-vars */
export enum AudioQuality {
  LOW = 16000, // 16 kbps
  MEDIUM = 32000, // 32 kbps
  HIGH = 64000, // 64 kbps
  ULTRA = 128000, // 128 kbps
}

export enum ConnectionState {
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  CONNECTED = "connected",
  FAILED = "failed",
  RECONNECTING = "reconnecting",
}
/* eslint-enable no-unused-vars */

export interface AudioSettings {
  inputDevice: string;
  outputDevice: string;
  quality: AudioQuality;
  noiseSuppression: boolean;
  echoCancellation: boolean;
  autoGainControl: boolean;
  pushToTalk: boolean;
  pushToTalkKey: string;
}

export interface VoiceConnection {
  connectionId: string;
  userId: string;
  sessionId: string;
  peerConnection: RTCPeerConnection;
  localStream: MediaStream | null;
  remoteStream: MediaStream | null;
  connectionState: ConnectionState;
  isMuted: boolean;
  volume: number;
}

export interface AudioDevice {
  deviceId: string;
  label: string;
  kind: MediaDeviceKind;
}

export interface VoiceState {
  isEnabled: boolean;
  isMuted: boolean;
  isSpeaking: boolean;
  volume: number;
  connections: Map<string, VoiceConnection>;
}

// Audio cue types
/* eslint-disable no-unused-vars */
export enum AudioTrigger {
  DICE_ROLL = "dice_roll",
  CRITICAL_HIT = "critical_hit",
  CRITICAL_FAIL = "critical_fail",
  LEVEL_UP = "level_up",
  COMBAT_START = "combat_start",
  COMBAT_END = "combat_end",
  PLAYER_JOIN = "player_join",
  PLAYER_LEAVE = "player_leave",
  TURN_CHANGE = "turn_change",
}
/* eslint-enable no-unused-vars */

export interface AudioCue {
  id: string;
  name: string;
  soundUrl: string;
  trigger: AudioTrigger;
  volume: number;
  priority: number;
}

// WebRTC Signaling Messages
export interface RTCSignalData {
  type: "offer" | "answer" | "ice-candidate";
  targetUserId: string;
  sourceUserId: string;
  sessionId: string;
  sdp?: RTCSessionDescriptionInit;
  candidate?: RTCIceCandidateInit;
}

export interface VoiceStateChangeData {
  userId: string;
  isMuted: boolean;
  isSpeaking: boolean;
}
